import { useAppConfig } from "@/queries/settings/use-app.query.ts";
import {
  SensitiveValue,
  SensitiveValueProps,
} from "@/components/sensitive-value/SensitiveValue.tsx";

export type SalarySensitiveValueProps = Omit<SensitiveValueProps, "defaultVisible">;

export function SalarySensitiveValue(props: SalarySensitiveValueProps) {
  const { data: appConfig } = useAppConfig();

  return (
    <SensitiveValue {...props} defaultVisible={appConfig?.ui.settings.show_full_salary ?? false} />
  );
}
